import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  structuredData?: object;
}

const SEO: React.FC<SEOProps> = ({
  title = 'Praktijk Iselda - EFT Relatietherapie & Systeemtherapie | Iselda',
  description = 'Praktijk Iselda biedt professionele EFT relatietherapie, gezinstherapie en individuele therapie. Iselda is gespecialiseerd systeemtherapeut en NVRG supervisor.',
  keywords = 'EFT, EFT therapie, relatietherapie, Praktijk Iselda, Iselda, systeemtherapie, gezinstherapie, emotionally focused therapy, NVRG therapeut',
  image = 'https://www.iselda.nl/images/iselda-og-image.jpg',
  url = 'https://www.iselda.nl',
  type = 'website',
  structuredData
}) => {
  const fullTitle = title.includes('Praktijk Iselda') ? title : `${title} | Praktijk Iselda`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
